import { AxiosError } from 'axios'

/** Client-side poll/request cancellation — not a server or workflow failure. */
export function isAbortOrCancelError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') {
    return true
  }
  if (error instanceof Error && error.name === 'AbortError') {
    return true
  }
  if (error instanceof AxiosError && error.code === 'ERR_CANCELED') {
    return true
  }
  if (error instanceof Error && error.name === 'CanceledError') {
    return true
  }
  return false
}
